import FuseUtils from '@fuse/utils';
import { CircularProgress, Icon, IconButton, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorIcon from '@material-ui/icons/Error';
import { excluirAlert } from 'app/services/alerts';
import clsx from 'clsx';
import { useFormikContext } from 'formik';
import React from 'react';
import { editarProdutoModalStyles } from './styles';

const TabImagensProduto = ({ onUploadImage }) => {
  const styles = editarProdutoModalStyles();

  const formik = useFormikContext();

  const handleUploadChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsBinaryString(file);

    reader.onload = async () => {
      const id = FuseUtils.generateGUID();
      let novasImagens = [
        ...formik.values.imagens,
        {
          id,
          url: `data:${file.type};base64,${btoa(reader.result)}`,
          thumbUrl: `data:${file.type};base64,${btoa(reader.result)}`,
          loading: true,
        },
      ];

      formik.setFieldValue('imagens', novasImagens);

      const formData = new FormData();
      formData.append('arquivo', file);

      const res = await onUploadImage(formData);

      let thumbUrl = res?.data?.thumbUrl;
      let url = res?.data?.url;

      if (!res?.data?.thumbUrl?.startsWith('http')) {
        thumbUrl = `${process.env.REACT_APP_BASE_URL}${res?.data?.thumbUrl}`;
        url = `${process.env.REACT_APP_BASE_URL}${res?.data?.url}`;
      }

      if (res.success) {
        novasImagens = novasImagens.map((img) =>
          img.id === id ? { ...res.data, loading: false, thumbUrl, url } : img
        );
      } else {
        novasImagens = novasImagens.map((img) => (img.id === id ? { ...img, loading: false, error: res.error } : img));
      }

      formik.setFieldValue('imagens', novasImagens);
    };

    reader.onerror = () => {
      console.log('error on load image');
    };
  };

  const handleDelete = (index) => {
    excluirAlert({
      confirmar: () => {
        const novasImagens = formik.values.imagens.filter((img, i) => i !== index);
        formik.setFieldValue('imagens', novasImagens);
      },
    });
  };

  const handleFavoritoChange = (index) => {
    const { imagens = [] } = formik.values;

    if (imagens[index].error || imagens[index].loading) {
      return;
    }

    const novasImagens = imagens.map((imagem, i) => ({ ...imagem, principal: index === i }));

    formik.setFieldValue('imagens', novasImagens);
  };

  const MAX_EXCEEDED = formik.values.imagens?.filter((img) => !img.error).length >= 5;

  const TooltipError = ({ error, children }) => {
    if (error) {
      return (
        <Tooltip title={error} placement="bottom">
          {children}
        </Tooltip>
      );
    }
    return <>{children}</>;
  };

  return (
    <div className="flex justify-center sm:justify-start flex-wrap -mx-8">
      <Tooltip
        title={MAX_EXCEEDED ? 'Quantidade máxima de imagens atingida' : 'Adicionar imagem'}
        placement="bottom"
        className={styles.tooltip}
      >
        <label
          htmlFor="button-file"
          className={clsx(
            styles.produtoImagemUpload,
            'flex items-center justify-center relative w-128 h-128 rounded-4 mx-8 mb-16 overflow-hidden cursor-pointer shadow-1 hover:shadow-5'
          )}
        >
          <input
            accept="image/jpeg, image/png"
            className="hidden"
            id="button-file"
            type="file"
            onChange={handleUploadChange}
            disabled={MAX_EXCEEDED}
          />
          <Icon fontSize="large" color="action">
            cloud_upload
          </Icon>
        </label>
      </Tooltip>

      {formik.values.imagens?.map((imagem, i) => {
        return (
          <div key={imagem.id} className={styles.imagemContainer}>
            <TooltipError error={imagem.error}>
              <a href={imagem.url} data-lightbox={`imagens-produto-${imagem.id}`}>
                <div
                  role="button"
                  tabIndex={0}
                  className={clsx(
                    styles.productImageItem,
                    'flex items-center justify-center relative w-128 h-128 rounded-4 mx-8 mb-4 overflow-hidden cursor-pointer shadow-1 hover:shadow-5',
                    imagem.principal && 'featured',
                    imagem.error && 'error'
                  )}
                  key={imagem.id}
                >
                  <img
                    className={clsx('max-w-none', 'w-auto', 'h-full', imagem.loading ? styles.imageLoading : '')}
                    src={imagem.thumbUrl}
                    alt={`Imagem número ${i + 1} do produto`}
                  />
                  {imagem.loading && <CircularProgress className={styles.imageIcon} />}
                  {imagem.error && <ErrorIcon fontSize="large" className={clsx(styles.imageIcon, 'error')} />}
                </div>
              </a>
            </TooltipError>

            <div className={styles.buttonContainer}>
              <Tooltip title="Excluir imagem" placement="bottom" className={styles.tooltip}>
                <IconButton className={styles.buttonDelete} aria-label="delete" onClick={() => handleDelete(i)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Adicionar como principal" placement="bottom" className={styles.tooltip}>
                <IconButton
                  className={clsx(styles.buttonStar, imagem.principal ? 'principal' : '')}
                  aria-label="favorite"
                  onClick={() => handleFavoritoChange(i)}
                >
                  <Icon>star</Icon>
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TabImagensProduto;
